module.exports = "https://static.zego.com/_next/static/images/RSA-5e98ec4c28621cbb01aa180958380f3e.svg";